import React from 'react';
import { Box, Grid, Skeleton, useTheme, useMediaQuery } from '@mui/material';

function BillingAndUsageSkeleton() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container padding={3}>
      <Grid container item alignItems='center' mb={isSmallScreen ? 2 : 4}>
        <Skeleton
          variant='text'
          width='250px'
          height='80px'
          sx={{ mt: -2, mb: -2 }}
        />

        <Grid
          container
          sx={{
            marginTop: isSmallScreen ? '10px' : '20px',
            backgroundColor: '#ffffff',
            padding: isSmallScreen ? '10px' : '20px',
            borderRadius: '20px',
            border: '1px solid #EEEEEE',
            justifyContent: 'flex-end',
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Skeleton variant='text' width='150px' height='40px' />
            <Skeleton variant='text' width='200px' height='20px' />
          </Grid>
          <Skeleton
            variant='rectangular'
            width='100%'
            height={isSmallScreen ? 8 : 15}
            sx={{ borderRadius: '10px', mb: 1.5 }}
          />

          <Grid
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              width: '100%',
            }}
          >
            <Skeleton variant='text' width='400px' height='20px' />
          </Grid>
          <Skeleton
            variant='rectangular'
            width={isSmallScreen ? '100%' : '200px'}
            height={40}
            sx={{ marginTop: isSmallScreen ? 2 : 0 }}
          />
        </Grid>
      </Grid>
      <Grid container item alignItems='center' width='100%'>
        <Skeleton
          variant='text'
          width='200px'
          height='80px'
          sx={{ mt: -3, mb: -2 }}
        />

        <Grid
          container
          alignItems='center'
          sx={{
            marginTop: isSmallScreen ? '10px' : '20px',
            marginBottom: isSmallScreen ? '10px' : '20px',
            backgroundColor: '#ffffff',
            borderRadius: '20px',
            border: '1px solid #EEEEEE',
            justifyContent: 'flex-end',
            padding: 2,
            paddingLeft: 3,
            gap: 2,
          }}
        >
          <Box display='flex' alignItems='center'>
            <Skeleton
              variant='rectangular'
              width={isSmallScreen ? 60 : 100}
              height={isSmallScreen ? 60 : 80}
            />
          </Box>
          <Box
            display='flex'
            flex={1}
            flexDirection={'column'}
            justifyContent={'flex-start'}
          >
            <Skeleton variant='text' width='200px' height='20px' />
            <Skeleton variant='text' width='100px' height='20px' />
          </Box>
          <Skeleton
            variant='rectangular'
            width={isSmallScreen ? '100%' : '200px'}
            height={40}
            sx={{ marginTop: isSmallScreen ? 2 : 0 }}
          />
        </Grid>
      </Grid>
      <Grid container item alignItems='center' width='100%'>
        <Skeleton
          variant='text'
          width='200px'
          height='80px'
          sx={{ mt: -3, mb: -2 }}
        />

        <Grid
          container
          alignItems='center'
          sx={{
            marginTop: isSmallScreen ? '10px' : '20px',
            marginBottom: isSmallScreen ? '10px' : '20px',
            backgroundColor: '#ffffff',
            borderRadius: '15px',
            border: '1px solid #EEEEEE',
            justifyContent: 'flex-end',
            padding: 2,
            paddingLeft: 3,
            gap: 1,
          }}
        >
          <Box display='flex' alignItems='center'>
            <Skeleton
              variant='circular'
              width={isSmallScreen ? 30 : 45}
              height={isSmallScreen ? 30 : 40}
            />
          </Box>
          <Box display='flex' flex={1} justifyContent={'space-between'}>
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton
              variant='text'
              width='200px'
              height='20px'
              sx={{ backgroundColor: 'transparent' }}
            />
          </Box>
        </Grid>
        <Grid
          container
          alignItems='center'
          sx={{
            marginTop: isSmallScreen ? '10px' : '20px',
            marginBottom: isSmallScreen ? '10px' : '20px',
            backgroundColor: '#ffffff',
            borderRadius: '15px',
            border: '1px solid #EEEEEE',
            justifyContent: 'flex-end',
            padding: 2,
            paddingLeft: 3,
            gap: 2,
          }}
        >
          <Box display='flex' alignItems='center'>
            <Skeleton
              variant='circular'
              width={isSmallScreen ? 30 : 45}
              height={isSmallScreen ? 30 : 40}
            />
          </Box>
          <Box display='flex' flex={1} justifyContent={'space-between'}>
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton variant='text' width='160px' height='20px' />
            <Skeleton
              variant='text'
              width='200px'
              height='20px'
              sx={{ backgroundColor: 'transparent' }}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BillingAndUsageSkeleton;
